import { Menu } from './../../theme/components/menu/menu.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommunicationPolicyDto, CommunicationPolicyResponseDto, FeatureNode, ScreenRoleDto, SystemScreenNode, UserRole } from './rolepermission.model';

@Injectable({
  providedIn: 'root'
})
export class RolepermissionService {

  constructor(public http: HttpClient) { }

  getAllRoles(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/RolePermission/GetAllRoles`);
  }

  getAllRolesTree(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/RolePermission/GetAllRolesTree`);
  }

  addUserRole(username: string, role: string, serviceId: Guid, profileId: Guid): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/Account/AddUserRole/${username}/${role}/${serviceId}/${profileId}`, {});
  }

  getUserRolesByUserId(userId: Guid): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/Account/GetUserRolesByUserId/${userId}`);
  }

  deleteUserRole(userId: Guid, roleId: Guid, serviceId: Guid): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/Account/DeleteUserRole/${userId}/${roleId}/${serviceId}`);
  }

  getUsersRoles(): Observable<UserRole[]> {
    return this.http.get<UserRole[]>(`${environment.apiUrl}/Profile/GetUsersRoles`);
  }

  addNewRole(role: UserRole): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/RolePermission/AddNewRole`, role);
  }

  updateRole(roleId: Guid, role: UserRole): Observable<UserRole> {
    return this.http.put<UserRole>(`${environment.apiUrl}/RolePermission/UpdateRole/${roleId}`, role);
  }

  deleteRole(roleId: Guid): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/RolePermission/DeleteRole/${roleId}`);
  }

  getSystemScreens(roleId: Guid): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/RolePermission/GetSystemScreens/${roleId}`);
  }

  giveRoleAccess(roleId: Guid, screen: SystemScreenNode): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/RolePermission/GiveRoleAccess/${roleId}`, screen);
  }

  removeRoleAccess(roleId: Guid, screen: SystemScreenNode): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/RolePermission/RemoveRoleAccess/${roleId}`, screen);
  }

  deletePermission(roleId: Guid, screenId: Guid): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/RolePermission/DeletePermission/${roleId}/${screenId}`);
  }

  getMenuItemsByRoleId(roleId: Guid): Observable<Menu[]> {
    return this.http.get<Menu[]>(`${environment.apiUrl}/RolePermission/GetMenuItemsByRoleId/${roleId}`);
  }

  getSystemScreenFeatures(screenId: Guid, roleId: Guid): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/RolePermission/GetSystemScreenFeatures/${screenId}/${roleId}`);
  }

  getScreenFeaturesByUrl(path: string): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/RolePermission/GetScreenFeaturesByUrl`, { path: path });
  }

  setFeaturePermission(screenId: Guid, roleId: Guid, feature: FeatureNode): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/RolePermission/SetFeaturePermission/${screenId}/${roleId}`, feature);
  }

  getScreenRoles(screenId: Guid): Observable<ScreenRoleDto[]> {
    return this.http.get<ScreenRoleDto[]>(`${environment.apiUrl}/RolePermission/GetScreenRoles/${screenId}`);
  }

  setScreenRolePermission(screenId: Guid, roleId: Guid, isActive: boolean): Observable<boolean> {
    return this.http.post<boolean>(
      `${environment.apiUrl}/RolePermission/SetScreenRolePermission/${screenId}/${roleId}`,
      isActive
    );
  }

  getActiveRoleIdsForScreen(screenId: Guid): Observable<string[]> {
    return this.http.get<string[]>(`${environment.apiUrl}/RolePermission/GetActiveRoleIdsForScreen/${screenId}`);
  }

  getScreenByUrl(url: string): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/RolePermission/GetScreenByUrl`, { path: url });
  }


  getCommunicationPolicies(policyScreenTypeId: string): Observable<CommunicationPolicyResponseDto[]> {
    return this.http.get<CommunicationPolicyResponseDto[]>(
      `${environment.apiUrl}/RolePermission/GetCommunicationPolicies/${policyScreenTypeId}`
    );
  }

  addCommunicationPolicy(dto: CommunicationPolicyDto): Observable<CommunicationPolicyResponseDto> {
    return this.http.post<CommunicationPolicyResponseDto>(
      `${environment.apiUrl}/RolePermission/AddCommunicationPolicy`,
      dto
    );
  }

  updateCommunicationPolicy(policyId: Guid, dto: CommunicationPolicyDto): Observable<CommunicationPolicyResponseDto> {
    return this.http.put<CommunicationPolicyResponseDto>(
      `${environment.apiUrl}/RolePermission/UpdateCommunicationPolicy/${policyId}`,
      dto
    );
  }

  deleteCommunicationPolicy(policyId: Guid): Observable<boolean> {
    return this.http.delete<boolean>(
      `${environment.apiUrl}/RolePermission/DeleteCommunicationPolicy/${policyId}`
    );
  }

  // ─────────────────────────────────────────────────────────────
}